<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-input
          v-model="search"
          placeholder="F.I.Sh yoki PINFL bo'yicha qidirish"
          clearable
          class="header-control"
          @input="onSearch"
          @clear="onSearch"
        />

        <el-button
          class="header-button header-button--right"
          type="primary"
          @click="openCreateDialog"
        >
          Yangi admin qo'shish
        </el-button>
      </div>
    </div>

    <el-table :data="admins" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column prop="fullname" label="F.I.Sh" min-width="240" />
      <el-table-column prop="pinfl" label="PINFL" min-width="170" />
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="170">
        <template #default="scope">
          {{
            scope.row.created_at
              ? $moment(scope.row.created_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="Amallar" fixed="right">
        <template #default="scope">
          <div class="action-grid">
            <el-button
              size="small"
              type="primary"
              @click="openEditDialog(scope.row)"
            >
              Tahrirlash
            </el-button>
            <el-tooltip
              v-if="!isCurrentAdmin(scope.row)"
              :disabled="!isLastAdmin"
              content="Tizimda kamida bitta admin qolishi shart"
              placement="top"
            >
              <span>
                <el-button
                  size="small"
                  type="danger"
                  :disabled="isLastAdmin"
                  @click="onDelete(scope.row)"
                >
                  O'chirish
                </el-button>
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Adminlar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-model="showDialog"
      :title="form.id ? 'Adminni tahrirlash' : 'Yangi admin qo\'shish'"
      width="500px"
      @closed="resetForm"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="F.I.Sh" prop="fullname">
          <el-input
            v-model="form.fullname"
            placeholder="Aliyev Vali Aliyevich"
            size="large"
          />
        </el-form-item>

        <el-form-item label="PINFL" prop="pinfl">
          <el-input
            v-model="form.pinfl"
            v-maska
            data-maska="##############"
            placeholder="14 ta raqam"
            size="large"
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDialog = false">Bekor qilish</el-button>
          <el-button type="primary" @click="onSubmit">Saqlash</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { vMaska } from "maska";

export default {
  name: "AdminsList",
  directives: { maska: vMaska },
  data() {
    const pinflValidator = (rule, value, callback) => {
      if (!/^\d{14}$/.test(value || "")) {
        callback(new Error("PINFL aynan 14 ta raqamdan iborat bo'lishi kerak"));
        return;
      }
      callback();
    };

    return {
      loading: false,
      admins: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: "",
      searchTimer: null,
      showDialog: false,
      form: {
        id: null,
        fullname: "",
        pinfl: "",
      },
      rules: {
        fullname: [
          { required: true, message: "F.I.Sh ni kiriting", trigger: "blur" },
          { min: 3, message: "Kamida 3 belgi", trigger: "blur" },
        ],
        pinfl: [{ required: true, validator: pinflValidator, trigger: "blur" }],
      },
    };
  },
  computed: {
    isLastAdmin() {
      return this.totalCount === 1;
    },
    currentUser() {
      return this.$store.state.user || {};
    },
  },
  methods: {
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    isCurrentAdmin(row) {
      if (this.currentUser.id && row.id) {
        return this.currentUser.id === row.id;
      }
      return !!row.pinfl && this.currentUser.pinfl === row.pinfl;
    },
    getAdmins() {
      this.loading = true;
      this.$http
        .get("api/v1/admin/admins", {
          params: {
            search: this.search || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.admins = data.admins || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getAdmins();
      }, 400);
    },
    openCreateDialog() {
      this.resetForm();
      this.showDialog = true;
    },
    openEditDialog(row) {
      this.form = {
        id: row.id,
        fullname: row.fullname || "",
        pinfl: row.pinfl || "",
      };
      this.showDialog = true;
    },
    resetForm() {
      this.form = {
        id: null,
        fullname: "",
        pinfl: "",
      };
      this.$refs.formRef?.clearValidate();
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        const payload = {
          fullname: this.form.fullname.trim(),
          pinfl: this.form.pinfl,
        };

        this.loading = true;
        const request = this.form.id
          ? this.$http.put(`api/v1/admin/admins/${this.form.id}`, payload)
          : this.$http.post("api/v1/admin/admins", payload);

        request
          .then(() => {
            ElNotification({
              title: "Tabriklaymiz",
              message: "Muvaffaqiyatli saqlandi",
              type: "success",
            });
            this.showDialog = false;
            if (!this.form.id) {
              this.currentPage = 1;
            }
            this.getAdmins();
          })
          .catch(({ response }) => {
            ElNotification({
              title: "Xatolik",
              message:
                response?.data?.message || "Iltimos, qayta urinib ko'ring.",
              type: "error",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    onDelete(row) {
      ElMessageBox.confirm(
        `${row.fullname} (${row.pinfl}) akkauntini o'chirasizmi? Bu admin tizimga kira olmay qoladi.`,
        "Diqqat!",
        {
          confirmButtonText: "Ha",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1/admin/admins/${row.id}`)
            .then(() => {
              ElMessage({ type: "success", message: "Admin o'chirildi" });
              if (this.admins.length === 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.getAdmins();
            })
            .catch(({ response }) => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message:
                  response?.data?.message || "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({ type: "info", message: "O'chirish bekor qilindi" });
        });
    },
    handleCurrentChange() {
      this.getAdmins();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getAdmins();
    },
  },
  mounted() {
    this.getAdmins();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 320px;
  flex-shrink: 0;
}

.header-button {
  flex-shrink: 0;
}

.header-button--right {
  margin-left: auto;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.action-grid :deep(.el-button) {
  margin: 0;
  width: 100%;
}
</style>
